import styles from "./VenuesSection.module.scss";
import useAppSelector from "../../../hooks/useAppSelector";
import React, {useEffect, useState} from "react";
import {VenueService} from "../../../services/venue.service";
import {setVenues} from "../../../store/venues/venuesSlice";
import useAppDispatch from "../../../hooks/useAppDispatch";
import {IVenue} from "../../../models/Venue";
import {useTranslation} from "react-i18next";
import SectionTitle from "../../../components/UI/SectionTitle/SectionTitle";
import SectionSubtitle from "../../../components/UI/SectionSubtitle/SectionSubtitle";
import {getVenueImage} from "../../../helpers/image.helper";
import {Link, useNavigate} from "react-router-dom";
import arrowRight from "../../../assets/images/icons/arrow-right-blue.svg";
import {openLoginPopup} from "../../../store/notification/notificationSlice";

const VenuesSection = () => {

    const dispatch = useAppDispatch();
    const {t} = useTranslation();
    const navigate = useNavigate();

    const {content} = useAppSelector(state => state.siteContentSlice);
    const {venues} = useAppSelector(state => state.venuesSlice);
    const {isAuthorized} = useAppSelector(state => state.profileSlice);
    const {activeGym} = useAppSelector(state => state.multiGymsSlice);

    const [filteredVenues, setFilteredVenues] = useState<IVenue[]>([]);

    useEffect(() => {
        getVenuesList();
    }, []);

    useEffect(() => {
        if (content.venuesItems && venues.length) {
            const settings = JSON.parse(content.venuesItems);
            const customSort = (a: any, b: any) => {
                const indexA = settings.order.indexOf(a.id);
                const indexB = settings.order.indexOf(b.id);
                return indexA - indexB;
            };
            const filteredAndSortedVenues = venues.filter(el => settings.selectedItems.includes(el.id)).sort(customSort);
            setFilteredVenues(filteredAndSortedVenues);
        }

    }, [venues]);

    const getVenuesList = async () => {
        try {
            const response = await VenueService.getVenues();
            if (response.status === 200) {
                dispatch(setVenues(response.data));
            }
        } catch (e) {
        }
    }

    const clickOnVenuesItem = (el: IVenue | null) => {
        if (isAuthorized && el) {
            navigate(`venues/${el.id}`)
        } else {
            dispatch(openLoginPopup({isOpen: true}));
        }
    }

    const renderWrapper = (length: number) => {
        if (length === 5) {
            return (
                <div className={`${styles.commonWrapper} ${styles.wrapper5}`}>
                    <div className={styles.column}>
                        <div className={styles.item}
                             onClick={() => clickOnVenuesItem(filteredVenues[0]?.id ? filteredVenues[0] : null)}
                             style={{backgroundImage: `url(${getVenueImage(activeGym.endpoint, filteredVenues[0]?.image)})`}}>
                        </div>
                        <div className={styles.item}
                             onClick={() => clickOnVenuesItem(filteredVenues[1]?.id ? filteredVenues[1] : null)}
                             style={{backgroundImage: `url(${getVenueImage(activeGym.endpoint, filteredVenues[1]?.image)})`}}>
                        </div>
                    </div>
                    <div className={styles.alone}>
                        <div className={styles.item}
                             onClick={() => clickOnVenuesItem(filteredVenues[2]?.id ? filteredVenues[2] : null)}
                             style={{backgroundImage: `url(${getVenueImage(activeGym.endpoint, filteredVenues[2]?.image)})`}}>
                        </div>
                    </div>
                    <div className={styles.column}>
                        <div className={styles.item}
                             onClick={() => clickOnVenuesItem(filteredVenues[3]?.id ? filteredVenues[3] : null)}
                             style={{backgroundImage: `url(${getVenueImage(activeGym.endpoint, filteredVenues[3]?.image)})`}}>
                        </div>
                        <div className={styles.item}
                             onClick={() => clickOnVenuesItem(filteredVenues[4]?.id ? filteredVenues[4] : null)}
                             style={{backgroundImage: `url(${getVenueImage(activeGym.endpoint, filteredVenues[4]?.image)})`}}>
                        </div>
                    </div>
                </div>
            )
        } else if (length === 4) {
            return (
                <div className={`${styles.commonWrapper} ${styles.wrapper4}`}>
                    {filteredVenues.map(el => {
                        return (
                            <div className={styles.item}
                                 onClick={() => clickOnVenuesItem(el)}
                                 style={{backgroundImage: `url(${getVenueImage(activeGym.endpoint, el?.image)})`}}>
                            </div>
                        )
                    })}
                </div>
            )
        } else if (length === 3) {
            return (
                <div className={`${styles.commonWrapper} ${styles.wrapper3}`}>
                    {filteredVenues.map(el => {
                        return (
                            <div className={styles.item}
                                 onClick={() => clickOnVenuesItem(el)}
                                 style={{backgroundImage: `url(${getVenueImage(activeGym.endpoint, el?.image)})`}}>
                            </div>
                        )
                    })}
                </div>
            )
        } else if (length === 2) {
            return (
                <div className={`${styles.commonWrapper} ${styles.wrapper2}`}>
                    {filteredVenues.map(el => {
                        return (
                            <div className={styles.item}
                                 onClick={() => clickOnVenuesItem(el)}
                                 style={{backgroundImage: `url(${getVenueImage(activeGym.endpoint, el?.image)})`}}>
                            </div>
                        )
                    })}
                </div>
            )
        } else if (length === 1) {
            return (
                <div className={`${styles.commonWrapper} ${styles.wrapper1}`}>
                    {filteredVenues.map(el => {
                        return (
                            <div className={styles.item}
                                 onClick={() => clickOnVenuesItem(el)}
                                 style={{backgroundImage: `url(${getVenueImage(activeGym.endpoint, el?.image)})`}}>
                            </div>
                        )
                    })}
                </div>
            )
        }

    }

    return (
        <section className={styles.section}>
            <div className={"container"}>
                <SectionTitle text={t("OurVenues")}/>
                <SectionSubtitle text={content.venuesDescription}/>
                {renderWrapper(filteredVenues.length)}
                <div className={styles.linkWrapper}>
                    <Link className={styles.link} to={"/venues"}>{t("ExploreVenues")}<img src={arrowRight}
                                                                                          alt={"move"}/></Link>
                </div>
            </div>
        </section>
    )
}

export default VenuesSection;